module.exports = __webpack_public_path__ + "static/photo-1-3a7d23881508d30e08d6498e5cf12af3.jpg";